<template>
    <div class="w1200">
        <div class="title">
            <span v-for="(item, index) in lottery.db" :key="index" :class="lottery.active === item.dictValue ? 'active' : ''"
                @click="lottery.active = item.dictValue; getList()">{{ item.dictLabel }}</span>
        </div>

        <div class="navigation">
            <div>
                <span> <router-link :to="`/ssddt?lotteryType=${lottery.active}`" style="all:unset">预测汇总</router-link>
                </span>
                <span @click="gotoExternalLink('kjh')">开奖号</span>
                <span @click="gotoExternalLink('zst')">走势图</span>
            </div>
            <b @click="recommendedExperts()" style="cursor:pointer;">推荐行家</b>
        </div>

        <h2>{{ lottery.db[lottery.active]?.dictLabel }}预测排行榜</h2>

        <div class="loadding" v-if="listLoading">loading...</div>
        <div class="grid" v-if="!listLoading">
            <div v-for="(item, index) in list" :key="index">
                <div class="tit">
                    <span>{{ item.title }}</span>
                    <span @click="itemMore(item)" class="more">更多</span>
                </div>
                <template v-if="item.title === '积分榜'">
                    <div class="subTit" style="grid-template-columns: 40px 1fr 100px">
                        <span>名次</span>
                        <span>缩水师</span>
                        <span>积分</span>
                    </div>
                    <div v-for="(ite, idx) in item.data" :key="idx" style="grid-template-columns: 40px 1fr 100px">
                        <span v-if="idx <= 2" class="img"><img :src="require(`@/assets/common/rank/${idx + 1}.gif`)"
                                alt=""></span>
                        <span v-else>{{ idx + 1 }}</span>
                        <span @click="view_history(ite)"><b style="color: #3F83B3;cursor: pointer">{{ ite.nickName
                                }}</b></span>
                        <span>{{ ite.totalScore }}</span>
                    </div>
                </template>
                <template v-else>
                    <div class="subTit">
                        <span>名次</span>
                        <span>缩水师</span>
                        <span>成绩</span>
                        <span>排名</span>
                        <span>积分</span>
                    </div>
                    <div v-for="(ite, idx) in item.data" :key="idx">
                        <span v-if="idx <= 2" class="img">
                            <img :src="require(`@/assets/common/rank/${idx + 1}.gif`)" alt="">
                        </span>
                        <span v-else>{{ idx + 1 }}</span>
                        <span @click="view_history(ite)"><b style="color: #3F83B3;cursor: pointer">{{ ite.nickName
                                }}</b></span>
                        <span>{{ ite.achievement }}</span>
                        <span>{{ ite.ranking }}</span>
                        <span>{{ ite.totalScore }}</span>
                    </div>
                </template>
            </div>
        </div>

        <el-dialog :title="popup.title" :visible.sync="popup.show" width="80%" :before-close="closePopup"
            :close-on-click-modal="false">
            <el-table :data="popup.tableData" :border="true" style="width: 100%"
                :header-cell-style="{ background: '#3F83B3', color: '#fff' }" v-loading="popup.loading">
                <el-table-column label="名次" type="index" width="60"></el-table-column>
                <el-table-column label="缩水师" prop="nickName"></el-table-column>
                <el-table-column label="成绩" prop="achievement" v-if="popup.title !== '积分榜'"></el-table-column>
                <el-table-column label="排名" prop="ranking" v-if="popup.title !== '积分榜'"></el-table-column>
                <el-table-column label="积分" prop="totalScore"></el-table-column>
            </el-table>
            <div style="text-align: center;margin-top: 20px;">
                <el-pagination background layout="prev, pager, next" :current-page="popup.pageNum"
                    :page-size="popup.pageSize" :total="popup.total" @current-change="changePage">
                </el-pagination>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import { queryPopularityList, queryPopularityPageList, queryPreRankingList, queryPreRankingPageList } from "@/api/home";
import { queryLotteryType } from "@/api/common"

import '@/dict';

export default {
    data() {
        return {

            awaitload: false,

            listPagin: {
                page: 1,
                limit: 10,
                total: 0
            },

            lottery: {
                db: [],
                active: '0'
            },
            list: [],
            listLoading: true,

            moreTitle: '',
            preIndexType: 0,

            popup: {
                show: false,
                title: '',
                loading: true,
                tableData: [],
                pageNum: 1,
                pageSize: 10,
                total: 0,

                params: {},
            }

        }
    },
    mounted() {
        this.getList()

        // 获取彩种
        queryLotteryType().then(res => this.lottery.db = res.data.map(item => {
            return { dictLabel: item.dictLabel, dictValue: item.dictValue }
        }))

    },
    methods: {
        // 走势图,开奖号  跳转外联链接
        gotoExternalLink(type) {
            const { active } = this.lottery;
            const mappingLottery = ['shuangseqiu', 'daletou', '3d', 'pailie3'];
            const url = `https://caipiao.ip138.com/${mappingLottery[active]}`;
            window.open(url + (type === 'zst' ? '/haoma/#1,1,0' : ''));
        },
        // 推荐行家
        recommendedExperts() {
            this.$vuex('vuex_menuActiveIndex', 2)
            this.$router.replace({
                path: '/ssdgw',
            })
        },
        view_history(item,) {
            let mappingLottery = ['ssq', 'dlt', 'fcsd', 'pls'];
            this.$router.push({
                path: '/dating_viewHistory',
                query: {
                    shrinkId: item.shrinkId || item.createUser,
                    number: item.number,
                    userName: item.nickName,
                    preType: mappingLottery[this.lottery.active],
                }
            })
        },
        getList() {
            this.listLoading = true
            this.list = []

            // 指标列表
            let mappingLottery = ['双色球', '大乐透', '福彩3D', '排列三'];
            let paramsArr = [
                ['80-89.9万', '50-59.9万', '15-21.9万', '4-9.9万', '5005注以下', '杀6蓝', '围4蓝', '90-99.9万'],
                ['24-26.9万', '15-17.9万', '3-5.9万', '1-1.9万', '4368注以下', '杀5后', '围3后', '27-29.9万'],
                ['700-799注', '400-599注', '200-399注', '50-199注', '1-49注', '800-899注'],
                ['700-799注', '400-599注', '200-399注', '50-199注', '1-49注', '800-899注'],
            ]
            const promises = paramsArr[this.lottery.active].map((preIndexName, index) => {
                return queryPreRankingList({
                    preType: this.lottery.active,
                    preIndexType: index,
                }).then(res => {
                    return {
                        title: `${mappingLottery[this.lottery.active]}${preIndexName}`,
                        data: res.data,
                        params: {
                            preType: this.lottery.active,
                            preIndexType: index,
                        }
                    };
                });
            });

            Promise.all(promises)
                .then(results => {

                    this.list = [...this.list, ...results]

                    // 人气列表
                    queryPopularityList({
                        preType: this.lottery.active,
                    }).then(res => {

                        res.data && (this.list.unshift({
                            title: '积分榜',
                            data: res.data.splice(0, 10) || [],
                            params: { preType: this.lottery.active, },
                        }))

                    });

                })
                .catch(error => console.error('有一个请求失败了：', error))
                .finally(() => this.listLoading = false);

        },
        itemMore(row) {
            this.popup.show = true
            this.popup.loading = true

            if (row) {
                this.popup.params = row.params;
                this.popup.title = row.title
            }
            let fun = this.popup.title === '积分榜' ? queryPopularityPageList : queryPreRankingPageList;

            let { pageNum, pageSize } = this.popup;
            fun({ ...this.popup.params, pageNum, pageSize, }).then(res => {
                this.popup.tableData = res.rows
                this.popup.total = res.total
            }).finally(() => this.popup.loading = false);

        },
        closePopup() {
            this.popup.show = false;
            this.popup.loading = true;
            this.popup.tableData = [];
            this.popup.total = 0;
            this.popup.pageNum = 1;
        },
        // 分页状态变化
        changePage(e) {
            this.popup.pageNum = e
            this.itemMore();
        },
    }
}
</script>

<style lang="scss" scoped>
.navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #3F83B3;

    span {
        display: inline-block;
        padding: 10px 20px;
        background-color: #dbdbdb;
        cursor: pointer;

        &:hover {
            background-color: #93d2f3;
        }
    }

    b {
        transition: color 0.3s, font-size 0.3s;

        &:hover {
            color: #3F83B3;
            font-size: 26px;
            font-weight: bold;
        }
    }
}

.grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 30px;

    >div {
        border: 1px solid #dadada;

        >div {
            &:nth-child(odd) {
                background-color: #F2F2F2;
            }

            &.tit,
            &.subTit {
                background-color: #FAE8CF;
            }

            &.tit {
                display: flex;
                justify-content: space-between;
                padding: 0 10px;

                .more {
                    cursor: pointer;

                    &:hover {
                        color: #3F83B3;
                        font-weight: bold;
                    }
                }
            }

            &:not(.tit) {
                display: grid;
                grid-template-columns: 40px 1fr 100px 50px 50px;
            }

            span {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 40px;
            }
        }
    }

    .img {
        display: flex;
        padding: 0;
        align-items: center;
        justify-content: center;

        img {
            width: 12px;
        }
    }
}

.title {
    margin: 20px 0;

    span {
        display: inline-block;
        padding: 15px 30px;
        background-color: #dbdbdb;
        cursor: pointer;

        &.active {
            background-color: #93d2f3;
            position: relative;

            &::after {
                content: "";
                position: absolute;
                bottom: -1px;
                left: 0;
                width: 100%;
                height: 2px;
                background-color: #3F83B3;
            }

            &::before {
                content: "";
                position: absolute;
                bottom: -5px;
                width: 10px;
                height: 10px;
                background-color: #3F83B3;
                transform: rotate(45deg);
                z-index: -1;
                left: calc(50% - 5px);
            }
        }
    }
}

.subMsg {
    border: 1px solid rgba(0, 0, 0, 0.1);

    .el-col {
        border: 1px solid rgba(0, 0, 0, 0.1);
        padding: 10px;
    }
}

.list {
    margin: 20px 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px;

    >div {
        border: 1px solid rgba(0, 0, 0, 0.1);

        >.tit {
            cursor: pointer;

            span {
                padding: 5px 10px;
            }
        }

        .tit {
            background-color: #fae8ce !important;
            display: flex;
            justify-content: space-between;
        }

        .grid {
            >div {
                display: grid;
                grid-template-columns: repeat(4, 1fr);

                &:nth-child(odd) {
                    background-color: #f2f2f2;
                }
            }

            span {
                padding: 10px;
                text-align: center;
            }
        }
    }
}

/* ===== 移动端适配（屏幕小于 1200px 即生效） ===== */
@media (max-width: 1200px) {
    /* 彩种切换：平分一行 */
    .title {
        display: flex;
        flex-wrap: wrap;

        span {
            flex: 1;
            min-width: 70px;
            text-align: center;
            padding: 10px 4px;
            font-size: 15px;
        }
    }

    /* 导航行：允许换行 */
    .navigation {
        flex-wrap: wrap;
        row-gap: 8px;

        span {
            padding: 8px 14px;
            font-size: 14px;
        }

        b {
            font-size: 14px;
        }
    }

    h2 {
        font-size: 16px;
    }

    /* 榜单：改为单列展示，压缩内部列宽 */
    .grid {
        grid-template-columns: 1fr;
        grid-gap: 16px;

        >div>div:not(.tit) {
            grid-template-columns: 34px 1fr 56px 44px 44px;
        }

        span {
            height: 36px;
            font-size: 13px;
        }
    }

    /* 排行榜弹窗：宽度自适应屏幕 */
    ::v-deep .el-dialog {
        width: 96% !important;
    }
}
</style>
